export default __webpack_public_path__ + "static/media/testimoni.f46b3471.jpg";